import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import './OnboardingFlow.scss';
import Questionnaire from '../../common/Questionnaire';
import Beginning from '../Beginning';
import Finish from '../Finish';
import SideNavStepProgressBar from '../../common/SideNavStepProgressBar/SideNavStepProgressBar';
import OnboardingHeader from '../OnboardingHeader/Index';
import OnboardingCompleted from '../OnboardingCompleted';
import { postRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
var OnboardingFlowContainer = /*#__PURE__*/function (_Component) {
  function OnboardingFlowContainer(props) {
    var _this;
    _classCallCheck(this, OnboardingFlowContainer);
    _this = _callSuper(this, OnboardingFlowContainer, [props]);
    _this.state = {
      state: 0,
      step: 0,
      questionnaire: Object.values(props.questionnaire),
      updateMenu: false,
      showFinishPage: false,
      uploadingResume: false
    };
    _this.setNextState = _this.setNextState.bind(_this);
    _this.updateQuestionnaire = _this.updateQuestionnaire.bind(_this);
    _this.handleNextStep = _this.handleNextStep.bind(_this);
    _this.handlePreviousStep = _this.handlePreviousStep.bind(_this);
    _this.setPreviousState = _this.setPreviousState.bind(_this);
    _this.handleMenuClick = _this.handleMenuClick.bind(_this);
    _this.handleMenuUpdate = _this.handleMenuUpdate.bind(_this);
    _this.handleShowFinishPage = _this.handleShowFinishPage.bind(_this);
    _this.handleResumeUpload = _this.handleResumeUpload.bind(_this);
    return _this;
  }
  _inherits(OnboardingFlowContainer, _Component);
  return _createClass(OnboardingFlowContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var userId = this.props.userId;
      analyticsTrack('Consultant Onboarding Started', {
        userId: userId
      });
    }
  }, {
    key: "setNextState",
    value: function setNextState(clorifyInfo) {
      var _this$state = this.state,
        state = _this$state.state,
        questionnaire = _this$state.questionnaire;
      if (questionnaire.length === 1) {
        this.setState({
          state: 2
        });
      } else {
        if (state === 0) {
          this.setState({
            clorifyInfo: clorifyInfo
          });
        }
        this.setState({
          state: state + 1
        });
      }
    }
  }, {
    key: "setPreviousState",
    value: function setPreviousState() {
      var state = this.state.state;
      this.setState({
        state: state - 1
      });
    }
  }, {
    key: "handleShowFinishPage",
    value: function handleShowFinishPage(value) {
      var _this$props = this.props,
        userId = _this$props.userId,
        finishViewLink = _this$props.finishViewLink;
      if (value) {
        analyticsTrack('User Reaches Onboarding Complete Page', {
          location: 'Onboarding Flow',
          userId: userId
        });
      }
      if (finishViewLink) {
        window.location = finishViewLink;
      } else {
        this.setState({
          showFinishPage: value
        });
      }
    }
  }, {
    key: "updateQuestionnaire",
    value: function updateQuestionnaire(updatedQuestionnaire) {
      this.setState({
        questionnaire: updatedQuestionnaire
      });
    }
  }, {
    key: "handleNextStep",
    value: function handleNextStep() {
      var _this$props2 = this.props,
        taggingUrl = _this$props2.taggingUrl,
        csrfToken = _this$props2.csrfToken;
      var step = this.state.step;
      if (step === 2) {
        postRequest(taggingUrl, {}, csrfToken);
      }
      this.setState(function (prevState) {
        return {
          step: prevState.step + 1
        };
      });
    }
  }, {
    key: "handlePreviousStep",
    value: function handlePreviousStep() {
      this.setState(function (prevState) {
        return {
          step: prevState.step - 1
        };
      });
    }
  }, {
    key: "handleMenuClick",
    value: function handleMenuClick(state, step) {
      this.setState({
        state: state,
        step: step
      });
    }
  }, {
    key: "handleMenuUpdate",
    value: function handleMenuUpdate() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.setState({
        updateMenu: value
      });
    }
  }, {
    key: "handleResumeUpload",
    value: function handleResumeUpload(uploading) {
      this.setState({
        uploadingResume: uploading
      });
    }
  }, {
    key: "renderQuestionnaires",
    value: function renderQuestionnaires() {
      var _this$props3 = this.props,
        name = _this$props3.name,
        userId = _this$props3.userId,
        questionnaireId = _this$props3.questionnaireId,
        questionnaireName = _this$props3.questionnaireName,
        questionabledId = _this$props3.questionabledId,
        questionableType = _this$props3.questionableType,
        csrfToken = _this$props3.csrfToken,
        finishViewLink = _this$props3.finishViewLink,
        isOwner = _this$props3.isOwner,
        onboardType = _this$props3.onboardType,
        getClaimInfoUrl = _this$props3.getClaimInfoUrl,
        claimInfoUrl = _this$props3.claimInfoUrl,
        profileUrl = _this$props3.profileUrl,
        profileQuestionnaireId = _this$props3.profileQuestionnaireId;
      var _this$state2 = this.state,
        state = _this$state2.state,
        questionnaire = _this$state2.questionnaire,
        step = _this$state2.step,
        updateMenu = _this$state2.updateMenu,
        uploadingResume = _this$state2.uploadingResume;
      if (state === 0) {
        return /*#__PURE__*/React.createElement(Beginning, {
          name: name,
          userId: userId,
          questionnaire: questionnaire,
          questionnaireName: questionnaireName,
          questionableId: questionabledId,
          questionableType: questionableType,
          questionnaireQuestionIds: questionnaire[0].map(function (x) {
            return x.id;
          }),
          csrfToken: csrfToken,
          getClaimInfoUrl: getClaimInfoUrl,
          claimInfoUrl: claimInfoUrl,
          isOwner: isOwner,
          setStateQuestionnaire: this.setNextState,
          updateQuestionnaire: this.updateQuestionnaire,
          finishViewLink: finishViewLink,
          onboardType: onboardType,
          handleNextStep: this.handleNextStep,
          updateMenu: updateMenu,
          handleMenuUpdate: this.handleMenuUpdate,
          handleResumeUpload: this.handleResumeUpload,
          uploadingResume: uploadingResume
        });
      }
      if (state === 2 && onboardType === 'lazy_onboard') {
        return /*#__PURE__*/React.createElement(Finish, {
          claimInfoUrl: claimInfoUrl,
          csrfToken: csrfToken,
          resourceLink: finishViewLink,
          resource: "ConsultantProfile",
          onboardType: onboardType,
          finish: true
        });
      }
      return /*#__PURE__*/React.createElement(Questionnaire, {
        userId: userId,
        questionnaireId: questionnaireId,
        questionnaireName: questionnaireName,
        questionnaire: questionnaire.slice(1),
        questionableId: questionabledId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        finishViewLink: finishViewLink,
        isOwner: isOwner,
        onboardType: onboardType,
        page: step === 0 ? step : step - 1,
        name: name,
        suggestedAnswers: this.state.clorifyInfo,
        profileUrl: profileUrl,
        finish: state === 2,
        profileQuestionnaireId: profileQuestionnaireId,
        handlePreviousStep: this.handlePreviousStep,
        handleNextStep: this.handleNextStep,
        setPreviousState: this.setPreviousState,
        updateMenu: updateMenu,
        handleMenuUpdate: this.handleMenuUpdate,
        handleShowFinishPage: this.handleShowFinishPage
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state3 = this.state,
        step = _this$state3.step,
        state = _this$state3.state,
        updateMenu = _this$state3.updateMenu,
        showFinishPage = _this$state3.showFinishPage,
        uploadingResume = _this$state3.uploadingResume;
      var _this$props4 = this.props,
        onboardType = _this$props4.onboardType,
        name = _this$props4.name,
        finishViewLink = _this$props4.finishViewLink,
        csrfToken = _this$props4.csrfToken,
        userId = _this$props4.userId,
        profileUrl = _this$props4.profileUrl,
        claimInfoUrl = _this$props4.claimInfoUrl;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(OnboardingHeader, {
        onboardType: onboardType,
        name: name,
        finishViewLink: finishViewLink,
        claimInfoUrl: claimInfoUrl,
        profileUrl: profileUrl,
        csrfToken: csrfToken,
        userId: userId,
        step: step,
        state: state,
        updateMenu: updateMenu,
        handleMenuUpdate: this.handleMenuUpdate,
        handleMenuClick: this.handleMenuClick,
        showFinishPage: showFinishPage
      }), showFinishPage ? /*#__PURE__*/React.createElement(OnboardingCompleted, {
        csrfToken: csrfToken,
        profileUrl: profileUrl,
        userId: userId,
        onboardType: onboardType
      }) : /*#__PURE__*/React.createElement("div", {
        className: "onboarding-beginning welcome"
      }, /*#__PURE__*/React.createElement("div", {
        className: "profile-faq"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sticky-content"
      }, /*#__PURE__*/React.createElement("h2", null, "Build your profile"), /*#__PURE__*/React.createElement(SideNavStepProgressBar, {
        step: step,
        state: state,
        userId: userId,
        updateMenu: updateMenu,
        uploadingResume: uploadingResume,
        handleMenuUpdate: this.handleMenuUpdate,
        handleMenuClick: this.handleMenuClick
      }))), /*#__PURE__*/React.createElement("div", {
        className: "questionnaire-container"
      }, this.renderQuestionnaires(), /*#__PURE__*/React.createElement("div", {
        className: "mobile-footer"
      }, /*#__PURE__*/React.createElement("nav", {
        className: "navbar navbar-default"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "navbar-header"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "navbar-toggle collapsed",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#clora-footer-navbar",
        "aria-expanded": "false"
      }, /*#__PURE__*/React.createElement("span", {
        className: "sr-only"
      }, "Toggle navigation"), /*#__PURE__*/React.createElement("span", {
        className: "icon-bar"
      }), /*#__PURE__*/React.createElement("span", {
        className: "icon-bar"
      }), /*#__PURE__*/React.createElement("span", {
        className: "icon-bar"
      })), /*#__PURE__*/React.createElement("span", {
        className: "navbar-text navbar-brand"
      }, "\xA9", ' ', new Date().getFullYear(), ' ', "Clora")), /*#__PURE__*/React.createElement("div", {
        className: "navbar-collapse collapse",
        id: "clora-footer-navbar"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "nav navbar-nav navbar-right"
      }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        href: "/privacy-policy"
      }, "Privacy Policy"))))))))));
    }
  }]);
}(Component);
OnboardingFlowContainer.propTypes = {
  name: PropTypes.string,
  userId: PropTypes.string.isRequired,
  questionnaireId: PropTypes.number.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionnaire: PropTypes.shape({}).isRequired,
  questionabledId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  finishViewLink: PropTypes.string,
  isOwner: PropTypes.bool.isRequired,
  onboardType: PropTypes.string,
  getClaimInfoUrl: PropTypes.string.isRequired,
  claimInfoUrl: PropTypes.string.isRequired,
  taggingUrl: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  profileQuestionnaireId: PropTypes.number.isRequired
};
OnboardingFlowContainer.defaultProps = {
  name: '',
  finishViewLink: '',
  onboardType: 'onboard'
};
export default OnboardingFlowContainer;